var map = {
	"./nevs_level_C.png": "82d1",
	"./nevs_level_CEn.png": "5fc5",
	"./nevs_level_D.png": "2073",
	"./nevs_level_DEn.png": "d7df",
	"./nevs_level_S.png": "f73d",
	"./nevs_level_SEn.png": "9f9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7f4";